module.exports = __webpack_public_path__ + "static/media/origin-correct.f09b38da.svg";